export {};

declare global {
  export interface Array<T> {
    firstOrDefault(): T;
  }
}

/**
 *  return first elememt in array or null
 */
Array.prototype.firstOrDefault = function(this: Array<any>) {
  return this && this.length ? this[0] : null;
};
